export const GESTOR_TAB_SEARCH_INPUT_CLASS =
  'min-h-[44px] w-full min-w-0 border-0 bg-transparent py-3 pl-10 pr-10 text-sm font-medium text-text-primary placeholder:text-text-secondary outline-none transition-colors focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent/25'
